
import React, { useState, useEffect } from 'react';
import { FaHeart, FaEye, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL, PHOTO_BASE_URL_Admin } from '../../Api/config';
import { debounce } from 'lodash';
import tenderNotFoundImage from '../../Assets/images/tenderNotFoundImage.png';
import { PremiumMemberAlert } from '../../Modals/PremiumMemberAlert';
import apiClient from '../../Api/apiClient';
import { Pagination } from 'antd';
import AdvanceSearchComponent from '../../Components/AdvanceSearchComponent/AdvanceSearchComponent.jsx'
const LimitedTenderCards = ({
  searchQuery,
  selectedCategory,
  selectedSubDeparment,
  selectedDistrict,
  selectedUpazila,
  selectedSource,
 
}) => {
  const navigate = useNavigate();
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [tenders, setTenders] = useState([]);
  const [totalTenders, setTotalTenders] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 5;
  

  const handleModalView = () => {
    setIsAlertModalOpen(true);
  };
  const handleModalClose = () => {
    setIsAlertModalOpen(false);
  };

  // Fetch tender data from API
  const fetchTenders = async () => {
    const searchQueryName = searchQuery || '';
    const type = 'free';
    const tenderSection = 'private';
    const subSectorName = selectedCategory || '';
    const subDepartmentName = selectedSubDeparment || '';
    const districtName = selectedDistrict || '';
    const upazilaName = selectedUpazila || '';
    const sourceName = selectedSource || '';
    const queryParams = `key=${searchQueryName}&sub_sector_name=${subSectorName}&sub_department_name=${subDepartmentName}&district_name=${districtName}&upazila_name=${upazilaName}&source_name=${sourceName}`;

    // &skip=${currentPage}&limit=${cardsPerPage}

    
    try {
      const response = await axios.get(`${API_BASE_URL}/user/visitor?${queryParams}`);
      const filteredTenders = response.data?.data?.filter(
        tender => tender.status === 1 && tender.permission === 'publish'
      );
      setTenders(filteredTenders || []);
      setTotalTenders(response.data?.total || 0);
    } catch (error) {
      console.error('Error fetching tenders:', error);
    }
  };


  const debouncedFetchTenders = debounce(() => {
    fetchTenders();
  }, 300);
  // Trigger the fetch when filters change
  useEffect(() => {
    debouncedFetchTenders();
    // Cleanup debounce
    return () => debouncedFetchTenders.cancel();
  }, [
    searchQuery,
    selectedCategory,
    selectedSubDeparment,
    selectedDistrict,
    selectedUpazila,
    selectedSource,
  ]);


  const handleViewDetailsClick = () => {
    navigate('/pricing', { state: { FromLimitedTender: 'FromLimitedTender' } });
  };



  const [totalAdvertisements, setTotalAdvertisements] = useState([]);

  const adsPerPage = 3;
  const startAdIndex = (currentPage - 1) * adsPerPage;
  const endAdIndex = startAdIndex + adsPerPage;
  const adsToShow = totalAdvertisements.slice(startAdIndex, endAdIndex);


  const fetchAdvertisements = async () => {
    try {
      const response = await apiClient.get('/user/add', {
        params: { panel_name: 'visitor_tender_list' },
      });
      setTotalAdvertisements(response.data.data);
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);


  const handleAdClicked = (link) => {
    const fullLink = /^https?:\/\//.test(link) ? link : `http://${link}`;
    window.open(fullLink, "_blank");
    
};


  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchTenders();
  };

  function itemRender(current, type, originalElement) {
    if (type === 'prev') {
      return <a className='flex items-center gap-1'> <FaAngleLeft /> Back</a>;
    }
    if (type === 'next') {
      return <a className='flex items-center gap-1'> Next <FaAngleRight /></a>;
    }
    return originalElement;
  }

  return (
    <div className="md:p-4 p-2 md:text-xs text-[9px]">

      <h3 className="md:text-lg text-sm font-semibold mb-4">
        Search Results:{' '}
        {tenders.length > 0 ? (
          <span className="text-green-600 text-sm bg-green-200 px-4 py-0.5 rounded-md">
            {tenders.length}
          </span>
        ) : (
          <span className="text-red-600 text-sm bg-red-200 px-4 py-0.5 rounded-md">
            No results found
          </span>
        )}
      </h3>



      <div className="flex flex-col md:flex-row gap-4">

        {/* <div>
          <AdvanceSearchComponent></AdvanceSearchComponent>
        </div> */}
        {/* Main Content */}
        <div className="w-full ">
          <div className="grid gap-4">
            {tenders.length > 0 ? (
              tenders.map((tender, index) => (
                <React.Fragment key={tender.id}>
                  {/* Tender Card */}
                  <div className="bg-BrowsBg  w-full shadow-md rounded-lg p-2 relative">
                    <div className="flex justify-between items-center">
                      <h2 className="md:text-lg text-sm font-semibold mb-4 w-10/12 ">
                       <span className='text-blue-900'>Tender Title:</span> {tender.name}
                      </h2>
                      <div className="absolute md:top-4 top-2 md:right-4 right-2 flex items-center text-gray-500 bg-red-100 px-4 py-1 rounded-md">
                        <FaEye className="mr-1" />
                        <span>{tender.total_view || 0}</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-1 gap-y-2">
                      <p className="flex">
                        <strong className="w-5/12">Tender ID:</strong>
                        <span>{tender.tender_id || 'N/A'}</span>
                      </p>
                      <p className="flex">
                        <strong className="w-5/12">Published on:</strong>
                        <span>
                          {new Date(tender.publish_on).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: '2-digit',
                          })}{' '}
                          ({tender.publish_on_before} days ago)
                        </span>
                      </p>
                      <p className="flex">
                        <strong className="w-5/12">Doc. Price:</strong>
                        <span>{tender.documents_price || 'N/A'}</span>
                      </p>
                      <p className="flex">
                        <strong className="w-5/12">Submission Date:</strong>
                        <span>
                          {new Date(tender.submission_date).toLocaleDateString(
                            'en-US',
                            {
                              year: 'numeric',
                              month: 'long',
                              day: '2-digit',
                            }
                          )}{' '}
                          {tender.tender_status === 'live' &&
                            `(${tender.expired_after} days more)`}
                        </span>
                      </p>
                    </div>
                    <div className="flex md:-ml-3 justify-center mt-4">
                      <button
                        onClick={handleModalView}
                        className="bg-DefaultColor text-white py-1.5 px-4 rounded-md hover:bg-DefaultHoverColor"
                      >
                        View Details
                      </button>
                      <PremiumMemberAlert
                        isOpen={isAlertModalOpen}
                        onClose={handleModalClose}
                      />
                    </div>
                  </div>

                  {/* Show Ad Every 2 Tenders in Mobile View */}
                  {index % 2 === 1 && totalAdvertisements.length > 0 && (() => {
                    const sortedAds = [...totalAdvertisements].sort((a, b) => a.serial - b.serial);
                    const adIndex = Math.floor(index / 2) % sortedAds.length;
                    const ad = sortedAds[adIndex];

                    return ad ? (
                      <div onClick={() => handleAdClicked(ad.url_link)} className="w-full cursor-pointer md:hidden bg-gray-200 rounded-lg shadow-md p-2 text-center">
                        <img
                          src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                          alt={ad.name}
                          className="w-full h-60 rounded-md object-cover"
                        />
                      </div>
                    ) : null;
                  })()}
                </React.Fragment>
              ))
            ) : (
              <div className="col-span-full text-center flex items-center justify-center w-full py-4 md:py-10">
                <img src={tenderNotFoundImage} alt="" className="w-80 h-80" />
              </div>
            )}
          </div>
        </div>

        {/* Sidebar Ads for Desktop View */}
        <div className="hidden md:flex flex-wrap justify-between gap-4 w-full md:w-1/4">
          <div className="w-full">
            <div className="sticky top-36 bottom-4 bg-gray-200 rounded-lg shadow-md  ">
              {adsToShow.length > 0 ? (
                adsToShow
                  .sort((a, b) => a.serial - b.serial)
                  .map((ad, index) => (
                    <div onClick={() => handleAdClicked(ad.url_link)} className="border cursor-pointer rounded-md my-2 border-black" key={index}>
                      <img
                        src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                        alt={ad.name}
                        className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md cover"
                      />
                    </div>
                  ))
              ) : null}
            </div>
          </div>
        </div>
      </div>


      <div className="my-3 flex justify-center">
        <Pagination
          current={currentPage}
          total={totalTenders} // Total count from API
          pageSize={cardsPerPage}
          onChange={handlePageChange}
          itemRender={itemRender}
          className="custom-pagination"
        />
      </div>
    </div>
  );
};

export default LimitedTenderCards;









